<template>
  <export-pdf :loading="loading" :filename="`resultado_campanha_${campaign._id}`" title="Resultado da campanha" :subtitle="title">
    <mf-pdf-item :title="title" :description="description" :name="$getLoggedUser().client">
      <campaign-info-cards :campaign="campaign" :offer-type="offerType" :products="products" />
    </mf-pdf-item>
    <mf-pdf-item title="Métricas da campanha" :name="$getLoggedUser().client">
      <campaign-metrics :metrics="campaignCardsMetrics" />
    </mf-pdf-item>
    <mf-pdf-item
      title="Uplift"
      description="Comparação da performance dos produtos no período da oferta x mesmo período do mês anterior."
      :name="$getLoggedUser().client"
    >
      <div class="uplift-container full-width">
        <slot name="uplift"></slot>
      </div>
    </mf-pdf-item>
    <mf-pdf-item title="Funil de cupons" :description="offerType === 'combo' ? 'Produtos gatilho' : ''" :name="$getLoggedUser().client">
      <div class="funnel-container">
        <funnel-data
          is-pdf-content
          :loading="loading"
          :metrics="campaignMetricsOfferType"
          :unit-metrics="unitMetrics"
          :offer-type="offerType"
          :activatable="activatable"
          :tab-value="0"
        />
      </div>
    </mf-pdf-item>
    <mf-pdf-item v-if="offerType === 'combo'" title="Funil de cupons" description="Produtos alvo" :name="$getLoggedUser().client">
      <div class="funnel-container">
        <funnel-data
          is-pdf-content
          :loading="loading"
          :metrics="campaignMetricsOfferType"
          :unit-metrics="unitMetrics"
          :offer-type="offerType"
          :tab-value="1"
          :activatable="activatable"
        />
      </div>
    </mf-pdf-item>
    <mf-pdf-item
      v-for="item in tabsItems"
      :key="item.name"
      title="Quantidade por loja"
      :description="`Exibição de até 10 lojas com ${item.name.toLowerCase()}`"
      :name="$getLoggedUser().client"
    >
      <div class="units-chart-container">
        <quantity-per-unit-chart
          key="pdf-quantity-per-unit-chart-clients"
          :tab-value="item.tabValue"
          is-pdf-content
          :metrics="unitMetrics"
          :offer-type="offerType"
        />
      </div>
    </mf-pdf-item>
    <mf-pdf-item title="Resultados por perfil" :name="$getLoggedUser().client">
      <slot name="profile-table"></slot>
    </mf-pdf-item>
    <mf-pdf-item title="Total dos resultados por produto" :name="$getLoggedUser().client">
      <slot name="total-products-table"></slot>
    </mf-pdf-item>
    <mf-pdf-item title="Resultados por produto" description="Exibição de até 10 resultados por produto" :name="$getLoggedUser().client">
      <slot name="products-table"></slot>
    </mf-pdf-item>
  </export-pdf>
</template>

<script>
import { QUERY_GET_ACCOUNT_IMAGES } from '@/modules/configuracoes-admin/graphql/index.js'
import ExportPdf from '@/components/ExportPdf.vue'
import CampaignInfoCards from './CampaignInfoCards.vue'
import CampaignMetrics from './CampaignMetrics.vue'
import QuantityPerUnitChart from '@/components/campaigns/QuantityPerUnitChart.vue'
import FunnelData from '@/components/campaigns/FunnelData.vue'

export default {
  name: 'ResultsPdf',
  components: {
    ExportPdf,
    CampaignInfoCards,
    CampaignMetrics,
    FunnelData,
    QuantityPerUnitChart,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    activatable: {
      type: Boolean,
      default: false,
    },
    campaignMetricsOfferType: {
      type: Object,
      default: () => {},
    },
    products: {
      type: Array,
      default: () => [],
    },
    campaignCardsMetrics: {
      type: Array,
      default: () => [],
    },
    unitMetrics: {
      type: Array,
      default: () => [],
    },
    campaign: {
      type: Object,
      default: () => {},
    },
    offerType: {
      type: String,
      validator: (value) =>
        [
          'general',
          'percentage',
          'dynamic_pricing_percentage',
          'takepay',
          'combo',
          'cashback_percentage',
          'cashback_absolute',
          'points',
          'nextbuycashback',
          'dynamic_rule',
          'crosssell',
        ].includes(value),
    },
  },
  data: () => ({
    benefitTypes: ['cashback_percentage', 'cashback_absolute', 'points'],
  }),
  computed: {
    title() {
      return this.campaign.name
    },
    description() {
      return this.campaign.description
    },
    logoImage() {
      return this.hotsite?.images?.finish?.logo
    },
    tabsItems() {
      const items = []
      if (this.offerType === 'combo') {
        items.push(
          {
            name: 'Produtos gatilho',
            tabValue: 0,
          },
          {
            name: 'Produtos alvo',
            tabValue: 1,
          }
        )
      } else {
        items.push({
          name: 'Produtos vendidos',
          tabValue: 0,
        })
      }
      items.push({
        name: `Clientes e ${this.benefitTypes.includes(this.offerType) ? 'benefícios' : 'descontos'}`,
        tabValue: this.offerType === 'combo' ? 2 : 1,
      })
      return items
    },
  },
  apollo: {
    hotsite: {
      query: QUERY_GET_ACCOUNT_IMAGES,
      fetchPolicy: 'network-only',
      update({ account }) {
        return account?.channels?.hotsite?.configuration?.assets
      },
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
::v-deep .full-width {
  width: 100%;
}

.funnel-container,
.units-chart-container {
  margin-top: -50px;
  width: 95%;
}
.units-chart-container {
  height: 400px;
}
</style>
